module.exports = __webpack_public_path__ + "static/media/findus3.4d688616.png";